import SecondaryMarketError from './SecondaryMarketError';

export default SecondaryMarketError;
